/**
 * @description Создать обработчик внутренних ошибок в компонентах.
 * @param {Logger} logger Журнал.
 * @returns {(function(Error): void)}
 */
export const createErrorHandler = (logger) => (err) => {
  logger.log('error', err);
  throw err;
};

export default { createErrorHandler };
